import { useSelect } from '@pankod/refine-antd'
import {
  BaseRecord,
  HttpError,
  UseSelectReturnType,
  UseSelectProps,
} from '@pankod/refine-core'

type SelectQueryResultWithoutData = Omit<
  UseSelectReturnType['queryResult'],
  'data'
>

type SelectQueryResultMeta<
  TData extends BaseRecord = BaseRecord,
  TMeta = {},
> = SelectQueryResultWithoutData & {
  data?: {
    data: TData[]
    total: any
    meta: TMeta & {
      currentPage: number
      pageSize: number
      totalPages: number
      totalItems: number
    }
    next?: boolean
  }
}

const useSelectWithMeta = <
  TData extends BaseRecord = BaseRecord,
  TError extends HttpError = HttpError,
  TMeta = {},
>(
  props: UseSelectProps<TData, TError>,
) => {
  const { queryResult: selectQueryResult, ...rest } = useSelect(props)
  const selectQueryResultMeta: SelectQueryResultMeta<TData, TMeta> =
    selectQueryResult as SelectQueryResultMeta<TData, TMeta>
  return { selectQueryResult: selectQueryResultMeta, ...rest }
}

export default useSelectWithMeta
